// WHY (#1306): the request-level Roads and Packaging multiselects,
// extracted from `DraftDictionarySelectionsCard` so they can be reused
// in two layouts:
//   - STANDARD / CONTAINER keep the standalone dictionary-selections
//     card, which now just hosts these fields.
//   - SIMPLE renders them inline inside `DraftBasicsCard` (under the
//     destinations field) because the simplified form drops the
//     separate roads/packaging card entirely.
// Hosting the field labels + the active-catalog query hooks here keeps
// both call sites byte-identical and avoids duplicating the catalog
// fetch logic.

import { useTranslation } from 'react-i18next';
import { useRequestsStore } from '../store.js';
import {
  useActivePackagingOptions,
  useActiveRoadOptions,
} from '../dictionarySelections.queries.js';
import { Field } from './DraftEditorPrimitives.js';
import { DictionarySelectionField } from './DictionarySelectionField.js';
import type { DraftScratchpad } from '../types.js';

export function DraftRoadsPackagingFields({ d }: { d: DraftScratchpad }) {
  const { t } = useTranslation(['requests']);
  const setRoadOptionIds = useRequestsStore((s) => s.setDraftRoadOptionIds);
  const setPackagingOptionIds = useRequestsStore((s) => s.setDraftPackagingOptionIds);

  const roadsQuery = useActiveRoadOptions();
  const packagingQuery = useActivePackagingOptions();

  return (
    <>
      <Field label={t('requests:draft.roads.label')}>
        <DictionarySelectionField
          selectedIds={d.roadOptionIds ?? []}
          selectedProjections={d.roadOptionProjections ?? []}
          onChange={setRoadOptionIds}
          catalog={roadsQuery.data ?? []}
          kindKey="roads"
          testId="roads-field"
        />
      </Field>
      <div style={{ height: 12 }} />
      <Field label={t('requests:draft.packaging.label')}>
        <DictionarySelectionField
          selectedIds={d.packagingOptionIds ?? []}
          selectedProjections={d.packagingOptionProjections ?? []}
          onChange={setPackagingOptionIds}
          catalog={packagingQuery.data ?? []}
          kindKey="packaging"
          testId="packaging-field"
        />
      </Field>
    </>
  );
}
